import { ArrowLeft, ArrowRight, Smartphone } from 'lucide-react';
import React, { FC, ReactNode } from 'react';
import CodeInput from 'react-code-input';

import ResendCodeButton from '~components/uas/ResendCodeButton';
import Field from '~components/ui/Field';
import Form from '~components/ui/Form';

interface Props {
  phone: string;
  name: string;
  onContinue: (code: string) => void;
  onBack: () => void;
  smsEndpoint?: string;
  description?: ReactNode;
}

const PhoneVerification: FC<Props> = ({
  onContinue,
  phone,
  onBack,
  name,
  smsEndpoint,
  description = 'Este paso es necesario para confirmar tu identidad y acceder a los beneficios de Citicinemas que la Universidad Autonoma de Sinaloa ofrece a sus estudiantes.',
}) => {
  const form = Form.useForm();
  const handleSubmit = (data: { code: string }) => {
    onContinue(data.code);
  };

  return (
    <div className="flex flex-col items-center gap-6 py-8 px-6 md:px-8">
      <span className="rounded-full bg-primary/5 p-4 text-primary dark:bg-primary/20">
        <Smartphone size={32} />
      </span>
      <div>
        <h1 className="h3 font-bold text-center">Verficia tu Celular</h1>
        <p className="text-support">
          Hemos enviado un código de 4 dígitos por SMS al{' '}
          <strong className="text-support">
            {phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}
          </strong>
        </p>
      </div>
      <Form form={form} onSubmit={handleSubmit} className="flex flex-col items-center gap-6">
        <Field name="code">
          <CodeInput
            name="code"
            type="number"
            inputMode="numeric"
            fields={4}
            inputStyle={{ backgroundColor: 'inherit' }}
          />
        </Field>
        <ResendCodeButton phone={phone} name={name} smsEndpoint={smsEndpoint} />
        <p className="text-support">{description}</p>
        <div className="grid grid-cols-2 gap-6 w-full">
          <button className="btn dark:btn-dark" type="button" onClick={() => onBack()}>
            <ArrowLeft size={16} /> <span>Regresar</span>
          </button>
          <button className="btn btn-primary" type="submit">
            <span>Continuar</span> <ArrowRight size={16} />
          </button>
        </div>
      </Form>
    </div>
  );
};

export default PhoneVerification;
